





























import { downloadFile } from '@/utils/helpers'
import Vue from 'vue'
import Component from 'vue-class-component'
import { Prop, Watch } from 'vue-property-decorator'
import { Action } from 'vuex-class'
import { FetchUserDataPayload, User } from '../utils/types'

@Component
export default class ExportUserDetails extends Vue {
  @Prop(Object) user!: User
  selectedJob = ''
  @Action fetchUserData!: (payload: FetchUserDataPayload) => Promise<User>;

  data = {
    user: this.user
  };

  @Watch('user')
  onUserPropChange () {
    this.data = {
      user: this.user
    }
  }

  async exportData () {
    const { data: { user: { id } }, selectedJob } = this
    if (!id) return false
    const user = await this.fetchUserData({ id: id, jobId: selectedJob })
    downloadFile(`דוח עבור ${user.firstName} ${user.lastName}.json`, JSON.stringify(user, undefined, 2))
    return true
  }
}

